/**
 * 翻译模型定义
 * 定义翻译相关的接口、类型和枚举
 */
/**
 * 翻译提供商枚举
 */
export var TranslationProvider;
(function (TranslationProvider) {
    /**
     * DeepSeek翻译API
     */
    TranslationProvider["DEEPSEEK"] = "deepseek-r1";
    /**
     * DeepSeek V3翻译API
     */
    TranslationProvider["DEEPSEEK_V3"] = "deepseek-v3";
    /**
     * Gemini 2.5 Flash Lite翻译API
     */
    TranslationProvider["GEMINI_2_5_FLASH_LITE"] = "gemini-2.5-flash-lite";
    /**
     * Gemini 2.5 Flash翻译API
     */
    TranslationProvider["GEMINI_2_5_FLASH"] = "gemini-2.5-flash";
    /**
     * Gemini 2.5 Pro翻译API
     */
    TranslationProvider["GEMINI_2_5_PRO"] = "gemini-2.5-pro";
})(TranslationProvider || (TranslationProvider = {}));
/**
 * 翻译状态枚举
 * 表示翻译操作的当前状态
 */
export var TranslationStatus;
(function (TranslationStatus) {
    /**
     * 空闲状态
     */
    TranslationStatus["IDLE"] = "idle";
    /**
     * 加载中
     */
    TranslationStatus["LOADING"] = "loading";
    /**
     * 成功完成
     */
    TranslationStatus["SUCCESS"] = "success";
    /**
     * 发生错误
     */
    TranslationStatus["ERROR"] = "error";
})(TranslationStatus || (TranslationStatus = {}));
//# sourceMappingURL=models.js.map